import * as React from "react";
import { cn } from "@/lib/utils";
import { Label } from "./label";

interface FormFieldProps {
  id: string;
  label: string;
  error?: string;
  hint?: string;
  required?: boolean;
  className?: string;
  children: React.ReactNode;
}

export function FormField({
  id,
  label,
  error,
  hint,
  required,
  className,
  children,
}: FormFieldProps) {
  const errorId = error ? `${id}-error` : undefined;
  const hintId = hint ? `${id}-hint` : undefined;

  return (
    <div className={cn("space-y-1.5", className)}>
      <Label htmlFor={id} required={required}>
        {label}
      </Label>
      {children}
      {hint && !error ? (
        <p id={hintId} className="text-xs text-muted-foreground">
          {hint}
        </p>
      ) : null}
      {error ? (
        <p id={errorId} role="alert" className="text-xs text-destructive">
          {error}
        </p>
      ) : null}
    </div>
  );
}

export function getFieldA11yProps(
  id: string,
  options: { error?: string; hint?: string } = {}
) {
  const describedBy: string[] = [];
  if (options.error) describedBy.push(`${id}-error`);
  if (options.hint) describedBy.push(`${id}-hint`);
  return {
    id,
    "aria-invalid": options.error ? true : undefined,
    "aria-describedby": describedBy.length ? describedBy.join(" ") : undefined,
  } as const;
}
